import styled from 'styled-components'

const Button = styled.button`
  font-style: normal;
  font-weight: ${({ theme }) => theme.weight.semi};
  font-size: ${({ theme }) => theme.size.smaller};
  flex-grow: 1;
  border-radius: 4px;
  height: 40px;
  cursor: pointer;
`

export default Button
